


















































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import BrandMixin from "@/mixins/brandMixin";

// Enums/Data
import { OrgFeatureKeys } from "@/data/constants";

@Component({
  components: {
    "payment-providers-provider": () =>
      import(
        "@/components/app/admin/settings/paymentProviders/paymentProvidersProvider.vue"
      ),
    "assigned-payment-providers-listing": () =>
      import(
        "@/components/app/admin/settings/paymentProviders/assignedPaymentProvidersListing.vue"
      ),
    "unassigned-payment-providers-listing": () =>
      import(
        "@/components/app/admin/settings/paymentProviders/unassignedPaymentProvidersListing.vue"
      ),
    "upmind-upgrade-message": () =>
      import("@/components/app/admin/upmind/upgradeMessage.vue")
  }
})
export default class PaymentProvidersSettingsView extends Mixins(BrandMixin) {
  // Computed

  public get unlimitedPaymentProviders() {
    return OrgFeatureKeys.UNLIMITED_PAYMENT_GATEWAYS;
  }
}
